import { NavLink, useLocation } from "react-router-dom";
import { LogoN, Sun, Moon } from "./Icons";
import { Theme } from "./theme";
import { HEADER_SLOT_ID } from "./HeaderSlot";

export const PAGES = [
  { to: "/scanner",     label: "Scanner"     },
  { to: "/journal",     label: "Journal"     },
  { to: "/instruments", label: "Instrumente" },
  { to: "/system",      label: "System"      },
];

export function pageLabel(pathname: string): string {
  return PAGES.find(p => pathname.startsWith(p.to))?.label ?? "";
}

export function Header({ theme, onToggleTheme }: { theme: Theme; onToggleTheme: () => void }) {
  const { pathname } = useLocation();
  return (
    <header className="nx-head">
      <div className="nx-brand">
        <LogoN />
        <span className="nx-brand-name">Nexus</span>
        <span className="nx-brand-page">/ {pageLabel(pathname)}</span>
      </div>
      <div style={{ display: "flex" }}>
        <div id={HEADER_SLOT_ID} style={{ display: "flex" }} />
        <button className="nx-icon-btn" onClick={onToggleTheme}
          aria-label={theme === "dark" ? "Helles Design" : "Dunkles Design"}>
          {theme === "dark" ? <Sun /> : <Moon />}
        </button>
      </div>
    </header>
  );
}

const links = PAGES.map(p => (
  <NavLink key={p.to} to={p.to} className={({ isActive }) => (isActive ? "active" : "")}>{p.label}</NavLink>
));

export function SideNav()  { return <nav className="nx-side" aria-label="Hauptnavigation">{links}</nav>; }
export function TabBar()   { return <nav className="nx-tabbar" aria-label="Hauptnavigation">{links}</nav>; }
